export class DoctoFaturaArquivoRequest {
    idUsuario: number;
    numFatBol: string;
    numNfeCte: string;
    doctoTransporteId: number;
    doctoPagtoId: number;
    numNFe: string;
    numBooking: string;
}
